import { nextTick, reactive } from 'vue';

import i18n from './vue-i18n.js';

declare const Beamer: {
    init(): void;
    show(): void;
    notificationNumber: number;
    update(config: Record<string, unknown>): void;
};

interface BeamerData {
    hasNotifications: boolean;
    isInitialized: boolean;
    user: { id?: string | number; account?: { type?: string } } | null;
}

class BeamerClient {
    data: BeamerData;

    constructor() {
        this.data = reactive<BeamerData>({
            hasNotifications: true,
            isInitialized: false,
            user: null,
        });
    }

    private isAvailable(): boolean {
        return typeof Beamer !== 'undefined';
    }

    init(user: BeamerData['user']) {
        if (!this.isAvailable()) {
            return;
        }
        this.data.user = user;
        this.configure();

        Beamer.init();

        this.data.isInitialized = true;
    }

    configure() {
        const updateHasNotification = (count?: number) => {
            nextTick(() => {
                this.data.hasNotifications = !!(count || Beamer.notificationNumber);
            });
        };

        Beamer.update({
            selector: '.changelog-selector',
            display: 'right',
            language: i18n.getContentLanguage().toUpperCase(),
            callback: updateHasNotification,
            onopen: updateHasNotification,
            user_id: this.data.user?.id || '',
            filter: this.data.user?.account?.type || '',
        });
    }

    changeLocale(locale: string) {
        if (!this.data.isInitialized || !this.isAvailable()) {
            return;
        }

        Beamer.update({ language: locale });
    }

    show() {
        if (!this.isAvailable()) {
            return;
        }
        Beamer.show();
    }

    get hasNotifications() {
        return this.data.hasNotifications;
    }
}

export default BeamerClient;
